import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-bar-chart-never-logged-age',
  templateUrl: './bar-chart-never-logged-age.component.html',
  styleUrls: ['./bar-chart-never-logged-age.component.css']
})
export class BarChartNeverLoggedAgeComponent implements OnInit {

          // per inizializzazione
          getAuthState: Observable<any>;
          getDoctorState: Observable<any>;
          isAuthenticated: boolean;
          user = null;
          errorMessage = null;
          subscription1: Subscription;
          subscription2: Subscription;
          subscription3: Subscription;
          subscription4: Subscription;
          subscription5: Subscription;
          subscription6: Subscription;
          title = "Fascia d'età";
          destination = 'never-logged';

          // elementi che servono per il bar-chart
          canvas: any;
          ctx: any;
          myChartNeverLoggedPatients: Chart;
    
          // ******************************************************************************************************************
          // seguenti righe: inizializzazione dei pazienti 
          // ******************************************************************************************************************
          neverLoggedGlobal020 = 0;
          neverLoggedGlobal2040 = 0;
          neverLoggedGlobal4060 = 0;
          neverLoggedGlobal60more = 0;

    
          loggedGlobal020 = 0;
          loggedGlobal2040 = 0;
          loggedGlobal4060 = 0;
          loggedGlobal60more = 0;

    
    
          GlobalPatients020 = 0;
          GlobalPatients2040 = 0;
          GlobalPatients4060 = 0;
          GlobalPatients60more =0;
   
    
          neverLoggedGlobalPatientsArray = [];
          loggedGlobalPatientsArray = [];
          neverLoggedPatientsGlobal = [];
          // ******************************************************************************************************************
          // bar chart dei pazienti 
          // ******************************************************************************************************************
          public barChartLabelsGlobalNeverLogged = ['0-20', '20-40','40-60','60+'];
          public barChartTypeGlobalNeverLogged = 'horizontalBar';
          public barChartLegendGlobalNeverLogged = true;
          public barChartDataGlobalNeverLogged = [
            {
              data: this.loggedGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal', 'teal','teal', 'teal'],
              hoverBackgroundColor: ['#066', '#066','#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
            },
            {
              data: this.neverLoggedGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered', 'orangered','orangered','orangered'],
              hoverBackgroundColor: ['#cc3700', '#cc3700','cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
            }];
          
    
    
          // constructor
          constructor(private store: Store<AppState>,
                      private doctorService: DoctorService,
                      private snackBar: MatSnackBar) {
            this.getAuthState = this.store.select(selectAuthState);
            this.getDoctorState = this.store.select(selectDoctorState);
          }
          // ******************************************************************************************************************
          // metodo all'inizio
          ngOnInit(): void {
            this.subscription6 = this.getAuthState.subscribe((state) => {
              this.isAuthenticated = state.isAuthenticated;
              this.user = JSON.parse(localStorage.getItem('user'));
              this.errorMessage = state.errorMessage;
              this.retrieveGlobalNeverLogged020();
            });
          }
          ngOnDestroy(): void {
            this.subscription1.unsubscribe();
            this.subscription2.unsubscribe();
            this.subscription3.unsubscribe();
            this.subscription4.unsubscribe();
            this.subscription5.unsubscribe();
            this.subscription6.unsubscribe();
          }
          // ******************************************************************************************************************
          // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
          // e in standard e poi tutti
          // i pazienti in ogni categoria per poter calcolare gli attivi
          // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
          
          retrieveGlobalNeverLogged020() {
            this.subscription1 = this.doctorService.getNeverLoggedAgeBracketsNumber("0","20").subscribe(npatients => {
              this.neverLoggedGlobal020 = parseInt(npatients.toString());
              this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobal020); // riempio il vettore del bar chart con standard
              this.retrieveGlobalNeverLogged2040();
  
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
          retrieveGlobalNeverLogged2040() {
            this.subscription2 = this.doctorService.getNeverLoggedAgeBracketsNumber("20","40").subscribe(npatients => {
              this.neverLoggedGlobal2040 = parseInt(npatients.toString());
              this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobal2040); // riempio vettore del bar-chart con telemedicina
              this.retrieveGlobalNeverLogged4060();
  
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }

          retrieveGlobalNeverLogged4060() {
            this.subscription3 = this.doctorService.getNeverLoggedAgeBracketsNumber("40","60").subscribe(npatients => {
              this.neverLoggedGlobal4060 = parseInt(npatients.toString());
              this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobal4060); // riempio vettore del bar-chart con telemedicina
              this.retrieveGlobalNeverLogged60more();

  
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
  
          retrieveGlobalNeverLogged60more() {
            this.subscription4 = this.doctorService.getNeverLoggedAgeBracketsNumber("60","1000").subscribe(npatients => {
              this.neverLoggedGlobal60more = parseInt(npatients.toString());
              this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobal60more); // riempio vettore del bar-chart con telemedicina
              this.retrieveGlobalAge();
  
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
        
          retrieveGlobalAge() {
            this.subscription5 = this.doctorService.getGlobalAgeNumber().subscribe(num => {
              this.GlobalPatients020 = num[0];
              this.GlobalPatients2040 = num[1];
              this.GlobalPatients4060 = num[2];
              this.GlobalPatients60more = num[3];
  
              this.loggedGlobal020 = this.GlobalPatients020 - this.neverLoggedGlobal020;
              this.loggedGlobalPatientsArray.push(this.loggedGlobal020); // riempio il vettore del bar chart con standard           
              this.loggedGlobal2040 = this.GlobalPatients2040 - this.neverLoggedGlobal2040;
              this.loggedGlobalPatientsArray.push(this.loggedGlobal2040); // riempio il vettore del bar chart con telemedicina
              this.loggedGlobal4060 = this.GlobalPatients4060 - this.neverLoggedGlobal4060;
              this.loggedGlobalPatientsArray.push(this.loggedGlobal4060); // riempio il vettore del bar chart con standard           
              this.loggedGlobal60more = this.GlobalPatients60more - this.neverLoggedGlobal60more;
              this.loggedGlobalPatientsArray.push(this.loggedGlobal60more); // riempio il vettore del bar chart con standard           
              this.canvasSetting();
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
         
          canvasSetting() {
              this.canvas = document.getElementById('myChartNeverLoggedAge') as HTMLCanvasElement;
              this.ctx = this.canvas.getContext('2d');
              this.myChartNeverLoggedPatients = new Chart(this.ctx, {
                type: this.barChartTypeGlobalNeverLogged,
                data: {
                  labels: this.barChartLabelsGlobalNeverLogged,
                  datasets: this.barChartDataGlobalNeverLogged,
                },
                options: {
                  maintainAspectRatio: true,
                  responsive: true,
    
                  scales: {
                    xAxes: [{
                      display: true,
                      stacked: false,
                      ticks: {
                        fontSize: 12,
                        fontStyle: 'bold',
                        fontFamily: 'Helvetica',
                        fontColor: '#006192'
                      }
                    }],
                    yAxes: [{
                      display: true,
                      stacked: false,
                      ticks: {
                        fontSize: 12,
                        fontStyle: 'bold',
                        fontFamily: 'Helvetica',
                        fontColor: '#006192'
                      }
                    }],
                  },
                  legend: {
                   
                    display: true,
                    position: 'top',
                    labels: {
                      usePointStyle: true,
                      fontColor: '#006192',
                      fontSize: 18,
                      fontFamily: 'Helvetica',
                    }
                  },
                  tooltips: {
                    // content: '{pathology}: {number}',
                    backgroundColor: '#1c1c1c',
                    bodyFontSize: 18,
                    titleFontSize: 18,
                    cornerRadius: 5,
                    caretPadding: 10
                  },
                  title: {
                    display: true,
                    text: "N° di utenti che hanno/non hanno effettuato l'accesso",
                    fontColor: '#006192',
                    fontSize: 20,
                    fontFamily: 'Helvetica',
                  },
                  hover: {
                    mode: 'nearest',
                    intersect: true
                  }
                }
              });
              } // dopo aver ottenuto tutti i dati creo il bar chart
          
        }
        